import * as signalR from '@microsoft/signalr';
import { getIdToken } from 'src/services/authService';
import { spreadSheetApiConfig } from 'src/services/pages/Documents/Auxiliares/spreadSheetApi';

const HUB_URL = `${spreadSheetApiConfig.baseUrl}/hubs/notifications`;

/**
 * Creates a SignalR HubConnection for the notifications hub.
 * Uses the Azure AD ID token as the bearer token via accessTokenFactory.
 */
export function createNotificationConnection(): signalR.HubConnection {
  return new signalR.HubConnectionBuilder()
    .withUrl(HUB_URL, {
      accessTokenFactory: () => getIdToken(),
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Warning)
    .build();
}
